export default __webpack_public_path__ + "static/media/(8).a1c76f75.jpeg";